export enum IncidenceOrigin {
    MANUAL = 1,    // Manual
    WHATSAPP = 2, // WhatsApp
    MAINTENANCE = 3    // Mantenimiento
}